import { Decimal, Numeric } from 'decimal.js-light';
import * as Eq from 'effect/Equivalence';
import * as O from 'effect/Option';
import { Refinement } from 'effect/Predicate';

/**
 * Re-export the data types from `decimal.js-light` so that we can import
 * from `@fmnts/core/decimal` and if we ever want to change the
 * depdency or something we can do this here.
 */
export { Decimal, Numeric };

/**
 * Test if value is a `Decimal`.
 *
 * @param u - The value to test.
 * @returns
 * `true` if the given parameter is an instance of
 * `Decimal`
 */
export const isDecimal: Refinement<unknown, Decimal> = (u) =>
  u instanceof Decimal;

/**
 * Coerces `value` to a `Decimal`.
 *
 * @param value Value to coerce
 */
export function fromUnknown(value: unknown): O.Option<Decimal> {
  try {
    const d = new Decimal(value as Numeric);
    return O.some(d);
  } catch {
    return O.none();
  }
}

/**
 * Utility function to check for equality of 2 decimals.
 *
 * @returns
 * `true` if decimals are considered equal.
 */
export const Equivalence: Eq.Equivalence<Decimal> = Eq.make<Decimal>((a, b) =>
  a.equals(b),
);
